export enum NOTIFICATION_TYPE {
	ERROR = "error",
	SUCCESS = "success",
	WARNING = "warning",
	INFO = "info",
}
